
































































































import { Component, Vue } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect, mdbBtn, mdbIcon, mdbTooltip } from '@folky-tools/mdbvue';
import { required } from 'vuelidate/lib/validators';
import { projectsService, pricingsService, usersService, businessesService, authorizationManagerService, notificationsService } from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Project } from '@/models/projects/project';
import { Pricing } from '@/models/pricings/pricing';
import { Business } from '@/models/businesses/business';
import { GenericResult } from '@/models/common/results/generic-result';
import { UserPermissionAction, UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import { BusinessType } from '@/models/businesses/business-type';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect,
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    },
    validations: {
        business: {
            tradeName: { required },
            type: { required },
            projects: { required },
            pricings: { required }
        }
    }
})
export default class NewProfileView extends Vue {
    private businessTypes: any[] = [
        { value: BusinessType.Business, text: 'common.businessType.business', selected: true },
        { value: BusinessType.Carrier, text: 'common.businessType.carrier' },
        { value: BusinessType.Wholesaler, text: 'common.businessType.wholesaler' },
        { value: -1, disabled: true },
        { value: BusinessType.Office, text: 'common.businessType.office' },
        { value: BusinessType.NeighborhoodCommunity, text: 'common.businessType.neighborhoodCommunity' },
        { value: -1, disabled: true },
        { value: BusinessType.Grouping, text: 'common.businessType.grouping' },
        { value: -1, disabled: true },
        { value: BusinessType.Diocese, text: 'common.businessType.diocese' },
        { value: BusinessType.Vicarage, text: 'common.businessType.vicarage' },
        { value: BusinessType.ParishUnit, text: 'common.businessType.parishUnit' },
        { value: BusinessType.Parish, text: 'common.businessType.parish' }
    ];
    private projects: Project[] = [];
    private pricings: Pricing[] = [];
    private businessesToLink: Business[] = [];
    private business: Business = new Business();
    private savingBusiness: boolean = false;

    private async beforeMount() {
        this.businessTypes[0].text = this.$t('common.businessType.business').toString();
        this.businessTypes[1].text = this.$t('common.businessType.carrier').toString();
        this.businessTypes[2].text = this.$t('common.businessType.wholesaler').toString();
        this.businessTypes[3].text = '-----';
        this.businessTypes[4].text = this.$t('common.businessType.office').toString();
        this.businessTypes[5].text = this.$t('common.businessType.neighborhoodCommunity').toString();
        this.businessTypes[6].text = '-----';
        this.businessTypes[7].text = this.$t('common.businessType.grouping').toString();
        this.businessTypes[8].text = '-----';
        this.businessTypes[9].text = this.$t('common.businessType.diocese').toString();
        this.businessTypes[10].text = this.$t('common.businessType.vicarage').toString();
        this.businessTypes[11].text = this.$t('common.businessType.parishUnit').toString();
        this.businessTypes[12].text = this.$t('common.businessType.parish').toString();
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.newProfileView.title');

        const projects: Project[] = await projectsService.getProjects();
        if (this.business.projects.length) {
            const projectIds = this.business.projects.map(p => p.id);
            projects.forEach(p => {
                if (projectIds.includes(p.id)) {
                    p.selected = true;
                    p.disabled = true;
                }
            });
        }
        this.projects = projects;

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.New
            })
        );
    }

    private async onChangeType(value: BusinessType, text: string) {
        this.business.type = value;
        await this.loadBusinessesToLink();
    }

    private async onChangeProject(value: number[], text: string): Promise<void> {
        if (value) {
            const selectedProjects: Project[] = [];
            this.projects.forEach(p => {
                if (typeof value === 'number') {
                    if (value === p.id) {
                        selectedProjects.push(p);
                    }
                } else {
                    if (value.includes(p.id)) {
                        selectedProjects.push(p);
                    }
                }
            });
            this.business.projects = selectedProjects;
            const selectedProjectIds = selectedProjects.map(p => p.id);

            const pricings: Pricing[] = ([] = await pricingsService.getPricings(selectedProjectIds));
            if (this.business.pricings.length) {
                const pricingtIds = this.business.pricings.map(p => p.id);
                pricings.forEach(p => {
                    if (pricingtIds.includes(p.id)) {
                        p.selected = true;
                    }
                });
            }

            this.pricings = pricings;

            await this.loadBusinessesToLink();
        } else {
            this.pricings = [];
            this.business.pricings = [];
            this.businessesToLink = [];
        }
    }

    private onChangePricing(value: number[], text: string) {
        if (value) {
            const selectedPricings: Pricing[] = [];
            this.pricings.forEach(p => {
                if (typeof value === 'number') {
                    if (value === p.id) {
                        selectedPricings.push(p);
                    }
                } else {
                    if (value.includes(p.id)) {
                        selectedPricings.push(p);
                    }
                }
            });
            this.business.pricings = selectedPricings;
        } else {
            this.business.pricings = [];
        }
    }

    private async loadBusinessesToLink() {
        if (this.business.type === BusinessType.Business || this.business.type === BusinessType.Carrier) {
            this.businessesToLink = await businessesService.getBusinessByTypeAndProjectId(BusinessType.Grouping, this.business.projects[0].id);
            return;
        }

        if (this.business.type === BusinessType.NeighborhoodCommunity) {
            this.businessesToLink = await businessesService.getBusinessByTypeAndProjectId(BusinessType.Office, this.business.projects[0].id);
            return;
        }

        if (this.business.type === BusinessType.Vicarage) {
            this.businessesToLink = await businessesService.getBusinessByTypeAndProjectId(BusinessType.Diocese, this.business.projects[0].id);
            return;
        }

        if (this.business.type === BusinessType.ParishUnit) {
            this.businessesToLink = await businessesService.getBusinessByTypeAndProjectId(BusinessType.Vicarage, this.business.projects[0].id);
            return;
        }

        if (this.business.type === BusinessType.Parish) {
            this.businessesToLink = await businessesService.getBusinessByTypeAndProjectId(BusinessType.ParishUnit, this.business.projects[0].id);
            return;
        }

        this.businessesToLink = [];
    }

    private async onChangeBusinessToLink(value: number, text: string) {
        this.business.linkedBusinesses = value && this.businessesToLink && this.businessesToLink.length > 0 ? this.businessesToLink.filter(b => b.id === value) : [];
    }

    private hasErrors(): boolean {
        this.$v.business.$touch();
        if (this.$v.business.$error) {
            return true;
        }
        return false;
    }

    private async saveBusiness(): Promise<void> {
        this.savingBusiness = true;

        if (this.hasErrors()) {
            this.savingBusiness = false;
            return;
        }

        try {
            const newBusinessResult: GenericResult = await businessesService.newBusiness(this.business);
            if (newBusinessResult.result) {
                notificationsService.showToastSuccessNotification('views.businesses.newProfileView.actions.save.success.notification');
                authorizationManagerService.addOrUpdatePermission(UserPermissionAction.Owner, UserEntityPermissionsType.Businesses, newBusinessResult.id);

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasCreated,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.New,
                        entityId: newBusinessResult.id
                    })
                );

                this.$router.push('/businesses');
                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBusiness = false;
        }
    }
}
